import { render, staticRenderFns } from "./IconViber.vue?vue&type=template&id=5c10066e&"
import script from "./IconViber.vue?vue&type=script&lang=js&"
export * from "./IconViber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports